import { _ as _sfc_main } from "./VaCard.vue_vue_type_script_lang-c814b43d.mjs";
import { openBlock, createBlock, resolveDynamicComponent, normalizeClass, normalizeStyle, withCtx, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaCard_vue_vue_type_style_index_0_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.tagComputed), {
    class: normalizeClass(["va-card", _ctx.classComputed]),
    style: normalizeStyle(typeof _ctx.cardStyles === "object" ? Array.isArray(_ctx.cardStyles) ? [..._ctx.cardStyles, `--va-0-stripe-color-computed: ${String(_ctx.stripeColorComputed)}`] : { ..._ctx.cardStyles, "--va-0-stripe-color-computed": String(_ctx.stripeColorComputed) } : _ctx.cardStyles + `;--va-0-stripe-color-computed: ${String(_ctx.stripeColorComputed)}`),
    href: _ctx.hrefComputed,
    target: _ctx.target,
    to: _ctx.to,
    replace: _ctx.replace,
    exact: _ctx.exact,
    "active-class": _ctx.activeClass,
    "exact-active-class": _ctx.exactActiveClass
  }, {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "style", "href", "target", "to", "replace", "exact", "active-class", "exact-active-class"]);
}
const _VaCard = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaCard as _
};
//# sourceMappingURL=VaCard-33e24573.mjs.map
